export enum GfpDocumentType {
  Digital = 'D',
  Electronic = 'E'
}
